import script from "./CustomerStatisticsInternal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerStatisticsInternal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerStatisticsInternal.vue?vue&type=style&index=0&id=1956f36c&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1956f36c"]])

export default __exports__